// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Hooks from "../../utils/Hooks.bs.jsx";
import * as React from "react";
import * as DomUtils from "../../utils/DomUtils.bs.jsx";
import * as LogUtils from "../../utils/LogUtils.bs.jsx";
import * as Reactfire from "reactfire";
import * as AppStorage from "../../utils/AppStorage.bs.jsx";
import * as SignInForm from "./SignInForm.bs.jsx";
import * as SignUpForm from "./SignUpForm.bs.jsx";
import * as Stdlib_JsExn from "@rescript/runtime/lib/es6/Stdlib_JsExn.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Auth from "firebase/auth";
import * as Stdlib_Promise from "@rescript/runtime/lib/es6/Stdlib_Promise.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Functions from "firebase/functions";
import * as ForgottenPasswordForm from "./ForgottenPasswordForm.bs.jsx";
import * as ForgottenPasswordSent from "./ForgottenPasswordSent.bs.jsx";
import * as Browser from "@firebase-web-authn/browser";

function Unauthenticated(props) {
  let app = Reactfire.useFirebaseApp();
  let auth = Reactfire.useAuth();
  let match = React.useState(() => "SignIn");
  let setView = match[1];
  let view = match[0];
  let match$1 = Hooks.usePromise(() => {
    let functions = Functions.getFunctions(app, "europe-central2");
    return Browser.signInWithPasskey(auth, functions);
  });
  let runSignInWithPasskey = match$1[1];
  let isOnlineStatus = DomUtils.useIsOnline();
  let isOnline = isOnlineStatus.data;
  let supportsWebAuthn = DomUtils.useSuportsPlatformWebauthn();
  let webAuthn = AppStorage.useLocalStorage(AppStorage.keyWebAuthn)[0];
  let webAuthnReady = supportsWebAuthn && webAuthn === "1";
  let startWebAuthnAutomatically = React.useRef(isOnline === true);
  React.useEffect(() => {
    if (startWebAuthnAutomatically.current) {
      startWebAuthnAutomatically.current = false;
      if (webAuthnReady) {
        runSignInWithPasskey();
      }
    }
  }, []);
  if (typeof view !== "object") {
    if (view === "SignIn") {
      return <SignInForm.make
        isOnline={isOnline}
        loadingOverlay={match$1[0].state === "pending"}
        onForgottenPassword={email => setView(param => ({
          TAG: "ForgotPassword",
          _0: email
        }))}
        onSignInWithGoogle={() => {
          Stdlib_Promise.$$catch(Auth.signInWithRedirect(auth, new Auth.GoogleAuthProvider()), error => {
            let exn = Stdlib_Option.getOrThrow(Stdlib_JsExn.fromException(error), undefined);
            LogUtils.captureException(exn);
            return Promise.reject(error);
          });
        }}
        onSignInWithPasskey={webAuthnReady ? runSignInWithPasskey : undefined}
        onSignInWithPassword={param => Auth.signInWithEmailAndPassword(auth, param.email, param.password).then(param => {})}
        onSignUp={() => setView(param => "SignUp")}
      />;
    } else {
      return <SignUpForm.make
        isOnline={isOnline}
        onSubmit={param => Auth.createUserWithEmailAndPassword(auth, param.email, param.password).then(param => {})}
        onGoBack={() => setView(param => "SignIn")}
      />;
    }
  } else if (view.TAG === "ForgotPassword") {
    return <ForgottenPasswordForm.make
      initialEmail={view._0}
      isOnline={isOnline}
      onGoBack={() => setView(param => "SignIn")}
      onSubmit={values => Auth.sendPasswordResetEmail(auth, values.email).then(() => {
        setView(param => ({
          TAG: "ForgotPasswordSent",
          _0: values.email
        }));
        return Promise.resolve();
      })}
    />;
  } else {
    return <ForgottenPasswordSent.make
      email={view._0}
      onGoBack={() => setView(param => "SignIn")}
    />;
  }
}

let make = Unauthenticated;

export {
  make,
}
/* Hooks Not a pure module */
